module.exports = __webpack_public_path__ + "static/media/1 20 trygt.41b0fe07.mp3";